import React from 'react'
import "slick-carousel/slick/slick.css";
import "../styles/carousel.css"
import Slider from 'react-slick'
import Chevron from './icons/chevron'

export function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <button aria-label="Next slide" className={`${className} `}>
      <Chevron
        style={{ ...style }}
        onClick={onClick}
        className={`h-auto w-2.5`}
      />
    </button>
  )
}

export function PrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <button aria-label="Previous slide" className={`${className} `}>
      <Chevron
        style={{ ...style }}
        onClick={onClick}
        className={`h-auto w-2.5`}
      />
    </button>
  )
}

function Carousel({ children, settingsOverrides }) {
  var settings = {
    dots: settingsOverrides?.dots || false,
    dotsClass: settingsOverrides?.dotsClass || 'slick-dots',
    infinite: settingsOverrides?.infinite || true,
    speed: settingsOverrides?.speed || 500,
    slidesToShow: settingsOverrides?.slidesToShow || 1,
    slidesToScroll: settingsOverrides?.slidesToScroll || 1,
    initialSlide: settingsOverrides?.initialSlide || 0,
    className: settingsOverrides?.className || '',
    customPaging:
      settingsOverrides?.customPaging ||
      function (i) {
        return <button>{i + 1}</button>
      },
    nextArrow: settingsOverrides?.nextArrow || <NextArrow />,
    prevArrow: settingsOverrides?.prevArrow || <PrevArrow />,
    responsive: settingsOverrides?.responsive || null,
  }
  return (
    <div>
      <Slider {...settings}>{children}</Slider>
    </div>
  )
}

export default Carousel
